// Single source of truth for the user-facing app version.
export const APP_VERSION = '1.0.0';
export const SUPPORT_EMAIL = 'support@kilalaride.com';
export const PH_HOTLINES = [
  { label: 'National Emergency', number: '911' },
  { label: 'Philippine Red Cross', number: '143' },
  { label: 'PNP Text Hotline', number: '0917 847 5757' },
];
